import css from '@styled-system/css';
import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import theme from '../theme';
const Overlay = styled.div `
  ${css({
    backgroundColor: 'rgba(0,0,0,0.3)',
    width: '100%',
    height: '100%',
    position: 'fixed',
    zIndex: 999,
    top: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'body',
    fontWeight: 'light',
})}
`;
function Modal({ children, onClose, theme }) {
    const el = document.createElement('div');
    const ref = useRef(null);
    let isTouch = false;
    useEffect(() => {
        document.body.appendChild(el);
        return () => {
            document.body.removeChild(el);
        };
    }, [el]);
    const handleClickOutside = (e) => {
        if (e.type === 'touchend') {
            isTouch = true;
        }
        if (e.type === 'click' && isTouch) {
            return;
        }
        if (ref &&
            ref.current &&
            !ref.current.contains(e.target) &&
            onClose) {
            onClose();
        }
    };
    const handleEsc = (e) => {
        if (ref && ref.current && onClose && e.keyCode === 27) {
            onClose();
        }
    };
    useEffect(() => {
        document.addEventListener('touchend', handleClickOutside, true);
        document.addEventListener('click', handleClickOutside, true);
        document.addEventListener('keydown', handleEsc, true);
        return () => {
            document.removeEventListener('touchend', handleClickOutside, true);
            document.removeEventListener('click', handleClickOutside, true);
            document.removeEventListener('keydown', handleEsc, true);
        };
    });
    return createPortal(React.createElement(Overlay, { theme: theme },
        React.createElement("div", { ref: ref }, children)), el);
}
Modal.defaultProps = { theme };
export default Modal;
//# sourceMappingURL=Modal.js.map